import type { PortalProviderAPI } from '@atlaskit/editor-common/portal';

import type { HubExternalInsertPlugin } from './hubExternalInsertPluginType';
import { createPlugin } from './pm-plugins/main';

export const hubExternalInsertPlugin: HubExternalInsertPlugin = ({ api }) => ({
	name: 'hubExternalInsert',
	pmPlugins() {
		return [
			{
				name: 'hubExternalInsert',
				plugin: ({ nodeViewPortalProviderAPI }: { nodeViewPortalProviderAPI?: PortalProviderAPI }) => {
					return createPlugin(api, nodeViewPortalProviderAPI);
				},
			},
		];
	},
});
